// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px"};